var render = function render(){var _vm=this,_c=_vm._self._c;return _c('u-context-menu',{ref:"context",staticClass:"erp-context-menu"},[_c('ul',[_c('menu-options-item',{attrs:{"close":"","label":"Excluir","icon":"times"},on:{"click":function($event){return _vm.$emit('excluir')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }